import FormHandler from './form/FormHandler';

const isVmForm = document.querySelector('.contact-us-form--vm form');

const contactUsFormHandler = new FormHandler(
  isVmForm ? '.contact-us-form--vm form' : '.contact-us-form form',
  isVmForm ? {
    name: ['required', 'max|255'],
    email: ['required', 'email'],
    message: ['required', 'max|1000'],
    'g-recaptcha-response': ['required'],
  } : {
    'first-name': ['required', 'alpha', 'max|255'],
    'last-name': ['required', 'alpha', 'max|255'],
    email: ['required', 'email'],
    phone: ['phone'],
    message: ['required', 'max|1000'],
    'g-recaptcha-response': ['required'],
  },
  isVmForm ? '.contact-us-form--vm .unknown-error' : '.contact-us-form .unknown-error'
);

contactUsFormHandler.mount();
